<template>
  <div class="main jcc ais">
    <div class="main__block">
      <div class="title">選擇預約項目</div>
      <div v-if="showReferralCodeSection && referralCodeData && referralCodeData.checked" class="flex flex-row jcc aic">
        <div class="referral-card">
          <div class="referral-code-block">
            <div class="referral-label">推薦碼</div>
            <div class="referral-code">{{ referralCodeData.referral_code }}</div>
          </div>
          <div class="referral-divider"></div>
          <div class="referral-period-block">
            <div class="referral-label">活動期間</div>
            <div class="referral-period">{{ referralCodeData.res_data.campaign_info.start }} 至 {{ referralCodeData.res_data.campaign_info.end }}</div>
          </div>
        </div>
        <!-- <a
          class="link-btn"
          style="margin-left: 10px;"
          @click.prevent="resetReferralCode"
        >
          刪除
        </a> -->
      </div>
      <div class="flex f-col jcs ais w-100">
        <div class="part__body">
          <div v-for="resvItem in booking.children" :key="`resvItem_${resvItem.id}`" class="choose__item square">
            <input v-model="tempResvItem" :value="resvItem" type="radio" />
            <div class="checkTag">
              <span v-html="resvItem.name"></span>
            </div>
          </div>
        </div>
        
        <div class="flex f-row jce w-100">
          <div @click="chooseTime" class="btn next">下一步</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import airleeClinicList from '../config/airleeClinicList';

export default {
  name: 'ChooseResvItem',
  components: {},
  data() {
    return {
      tempResvItem: ''
    };
  },
  methods: {
    resetReferralCode() {
    },
    checkClinic() {
      const clinicCode = this.$route.query.clinicCode;
      if (clinicCode) {
        localStorage.setItem('clinicCode', clinicCode);
      } else {
        alert('診所代碼錯誤,請重新登入！');
        this.backToLogin();
      }
    },
    backToLogin() {
      const clinicCode = this.$route.query.clinicCode;
      this.$router.push(`/login?clinicCode=${clinicCode}`);
    },
    async chooseTime() {
      const clinicCode = localStorage.getItem('clinicCode');
      if (!this.tempResvItem) {
        alert('尚未選擇預約子項目！');
      } else {
        try {
          await this.$store.dispatch('resvModule/setMed', { 
            data: {
              name: this.tempResvItem.name,
              booking_id_1: this.tempResvItem.parent.id,
              booking_id_2: this.tempResvItem.id,
              schlen: parseInt(this.tempResvItem.schlen),
              checkin: parseInt(this.tempResvItem.checkin)
            }, 
            clinicCode, 
          });
          await this.$store.dispatch('resvModule/setTime', { data: this.needTime, clinicCode, });
          this.$router.push(`/choose-time?clinicCode=${this.$route.query.clinicCode}`);
        } catch (e) {
          const tokenError = ['無效的token', 'token錯誤', '該token已失效'];
          if (tokenError.indexOf(e) > -1) {
            alert('請重新登入');
            this.$router.push(`/login?clinicCode=${clinicCode}`);
          } else if (e == 'his api not found') {
            alert('請重新登入');
            this.$router.push(`/login?clinicCode=${clinicCode}`);
          } else {
            alert(e);
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters('authModule', ['customerByC', 'clinicByC', 'mgmIsEnableByC']),
    ...mapGetters('resvModule', ['roomByC', 'bookingByC']),
    ...mapGetters('mgmModule', ['referralCodeDataByC']),
    ...mapGetters('authModule', ['newpatientByC']),
    customer() {
      const clinicCode = this.$route.query.clinicCode;
      return this.customerByC(clinicCode);
    },
    room() {
      const clinicCode = this.$route.query.clinicCode;
      return this.roomByC(clinicCode);
    },
    booking() {
      const clinicCode = this.$route.query.clinicCode;
      return this.bookingByC(clinicCode);
    },
    needTime() {
      let schlen = parseInt(this.tempResvItem.schlen);
      let checkin = parseInt(this.tempResvItem.checkin);
      return { schlen, checkin, };
    },
    clinic() {
      const clinicCode = this.$route.query.clinicCode;
      return this.clinicByC(clinicCode);
    },
    referralCodeData() {
      const clinicCode = this.$route.query.clinicCode;
      return this.referralCodeDataByC(clinicCode);
    },
    mgm_is_enable() {
      const clinicCode = this.$route.query.clinicCode;
      return this.mgmIsEnableByC(clinicCode);
    },
    isHqOp() {
      return false;
    },
    settings() {
      const clinicCode = this.$route.query.clinicCode;
      const online_resv_np = localStorage.getItem(`online_resv_np_${clinicCode}`);
      return {
        online_resv_np: online_resv_np ? JSON.parse(online_resv_np) : 0,
      };
    },
    cusType() {
      let cusType = 'nnp';
      if (Object.keys(this.customer).length > 0) {
        cusType = 'cus';
      }
      if (Object.keys(this.newpatient).length > 0) {
        cusType = 'np';
      }
      return cusType;
    },
    newpatient() {
      const clinicCode = this.$route.query.clinicCode;
      return this.newpatientByC(clinicCode);
    },
    showReferralCodeSection() {
      // 1) 先判斷是否愛爾麗，愛爾麗不受 mgm_is_enable 控制
      if (this.isAirleeClinic) {
        // 2) 愛爾麗：僅限新患者 + 非他院舊客 + 新患者預約開放
        return (
          !this.isHqOp &&
          this.cusType === 'nnp' &&
          this.settings.online_resv_np == 1
        );
      }
      // 3) 一般診所：需 MGM 功能開啟
      if (parseInt(this.mgm_is_enable, 10) !== 1) {
        return false;
      }
      return true;
    },
    isAirleeClinic() {
      // 檢查當前診所是否為愛爾麗及是否使用推薦碼
      if (airleeClinicList.some(clinic => clinic.clinic_sn === this.$route.query.clinicCode)) {
        return true;
      }
      return false;
    },
  },
  async created() {
    await this.checkClinic();
    window.scrollTo(0, 0);
  },
};
</script>
